<div class="user-profile-page min-h-screen bg-[#f8fafc] p-3 font-fira-condensed">
    <!-- Top Header with Save and Cancel Buttons -->
    <div *ngIf="!embeddedInModal" class="mb-4 flex items-center justify-between">
        <div class="flex items-center">
            <h1 class="text-3xl font-bold text-primary">Add/Edit User</h1>
        </div>
        <div class="flex items-center gap-4">
            <button type="button" (click)="toggleEditMode()"
                class="px-5 py-2 bg-white border border-slate-300 text-slate-600 font-bold rounded-md hover:bg-slate-50 transition-all text-sm tracking-widest uppercase">
                Cancel
            </button>
            <button type="button" (click)="saveProfile()"
                class="px-5 py-2 bg-[#0d2e5e] text-white font-bold rounded-md hover:bg-[#07244d] transition-all text-sm flex items-center gap-2 tracking-widest uppercase shadow-sm">
                <span class="text-lg leading-none">✓</span> Save User
            </button>
        </div>
    </div>

    <form [formGroup]="profileForm">
        <!-- Section 1: User Information -->
        <div class="bg-white rounded-lg shadow-sm border border-slate-200 overflow-hidden mb-3">
            <div class="px-4 py-2.5 border-b border-slate-100 flex justify-between items-center bg-[var(--primary)]">
                <h2 class="text-sm font-semibold text-white">User Information</h2>
                <label class="flex items-center gap-2 cursor-pointer group">
                    <div class="relative w-10 h-5">
                        <input type="checkbox" formControlName="isActive" class="sr-only peer">
                        <div
                            class="w-10 h-5 bg-slate-200 rounded-full peer-checked:bg-white transition-all after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:after:translate-x-[18px] peer-checked:after:bg-[var(--primary)] shadow-sm">
                        </div>
                    </div>
                    <span
                        class="text-xs font-bold text-white tracking-wide group-hover:text-white/90 transition-colors">Is
                        Active</span>
                </label>
            </div>
            <div class="p-4 bg-slate-100">
                <div class="grid grid-cols-12 gap-3">
                    <div class="col-span-12 lg:col-span-10">
                        <div class="grid grid-cols-1 md:grid-cols-3 gap-3">
                            <!-- Row 1: User Name, First Name, Last Name -->
                            <app-input formControlName="userName" label="User Name" placeholder="harold"
                                [required]="true"></app-input>
                            <app-input formControlName="firstName" label="First Name" placeholder="HAROLD"
                                [required]="true"></app-input>
                            <app-input formControlName="lastName" label="Last Name" placeholder="HERNANDEZ"
                                [required]="true"></app-input>

                            <!-- Row 2: Password, Confirm Password, Idle Time -->
                            <app-input formControlName="password" label="Password" type="password"
                                placeholder="********" [required]="true"></app-input>
                            <app-input formControlName="confirmPassword" label="Confirm Password" type="password"
                                placeholder="********" [required]="true"></app-input>
                            <div class="w-full">
                                <app-input formControlName="idleTime" label="Idle Time"
                                    placeholder="40,000"></app-input>
                            </div>

                            <!-- Row 3: User Type Inline -->
                            <div class="col-span-1 md:col-span-3 pt-2 flex items-center gap-6">
                                <label
                                    class="text-xs font-extrabold text-[#d32f2f] uppercase tracking-widest whitespace-nowrap">USER
                                    TYPE :</label>
                                <div class="flex flex-wrap gap-x-8 gap-y-3">
                                    <label *ngFor="let type of userTypes"
                                        class="flex items-center gap-2 cursor-not-allowed group opacity-60">
                                        <input type="checkbox" [checked]="type.selected" disabled
                                            class="w-4 h-4 rounded border-slate-300 text-[#0d2e5e] focus:ring-offset-0 focus:ring-0 cursor-not-allowed">
                                        <span
                                            class="text-sm text-slate-600 font-bold group-hover:text-slate-900">{{type.label}}</span>
                                    </label>
                                </div>
                            </div>

                            <!-- Row 4: Description (Spanning 3 columns) -->
                            <div class="col-span-1 md:col-span-3 pt-2">
                                <app-input formControlName="description" label="Description" type="textarea"
                                    [rows]="1"></app-input>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Section 2: Work Time & Emergency Access -->
        <div class="bg-white rounded-lg shadow-sm border border-slate-200 overflow-hidden mb-3">
            <div class="px-4 py-2.5 border-b border-slate-100 flex justify-between items-center bg-[var(--primary)]">
                <h2 class="text-sm font-semibold text-white">Work Time & Access</h2>
            </div>
            <div class="grid grid-cols-1 lg:grid-cols-2">
                <!-- Work Time -->
                <div class="p-6 border-r border-slate-100 bg-slate-50/50">
                    <h3 class="text-xs font-bold text-slate-500 uppercase tracking-widest mb-4">Work Time</h3>
                    <div class="grid grid-cols-2 gap-4">
                        <app-input formControlName="fromTime" label="From Time" placeholder="00:00"
                            type="time"></app-input>
                        <app-input formControlName="toTime" label="To Time" placeholder="00:00" type="time"></app-input>
                    </div>
                </div>

                <!-- Emergency Access -->
                <div class="p-6 bg-slate-50/50">
                    <h3 class="text-xs font-bold text-slate-500 uppercase tracking-widest mb-4">Emergency Access</h3>
                    <div class="grid grid-cols-12 gap-6">
                        <div class="col-span-7 space-y-4">
                            <app-input formControlName="emergencyPassword" label="Password" type="password"></app-input>
                            <div class="grid grid-cols-2 gap-4">
                                <app-date-picker formControlName="emergencyFromDate" label="From Date"
                                    placeholder="12/30/1899"></app-date-picker>
                                <app-date-picker formControlName="emergencyToDate" label="To Date"
                                    placeholder="12/30/1899"></app-date-picker>
                            </div>
                        </div>
                        <div class="col-span-5 border-l border-slate-200 pl-4 space-y-3 font-fira-condensed">
                            <span
                                class="block text-[10px] font-bold text-slate-400 uppercase tracking-wider mb-2">Access
                                Roles</span>
                            <label *ngFor="let role of emergencyRoles"
                                class="flex items-center gap-2 cursor-pointer group">
                                <input type="checkbox" [checked]="role.selected"
                                    class="w-3.5 h-3.5 rounded border-slate-300 text-[#0d2e5e]">
                                <span
                                    class="text-xs font-bold text-slate-700 group-hover:text-slate-900">{{role.label}}</span>
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Section 3: Assignment Roles (Table) -->
        <div class="bg-white rounded-lg shadow-sm border border-slate-200 overflow-hidden mb-3">
            <div
                class="table-header bg-[var(--primary)] px-4 py-2.5 border-b border-slate-100 flex justify-between items-center">
                <div class="flex items-center gap-3">
                    <!-- Removed red bar, using standard header style but keeping title distinct if needed, or matching others. 
                          User asked to match Add Patient but also keep table typed. 
                          I will use the white text header style for consistency with other sections. -->
                    <h2 class="text-sm font-semibold text-white">Role :</h2>
                </div>
                <div class="flex gap-2">
                    <button type="button"
                        class="w-6 h-6 bg-white/20 text-white rounded flex items-center justify-center font-bold text-lg hover:bg-white/30 transition-colors">+</button>
                    <button type="button"
                        class="w-6 h-6 bg-white/20 text-white flex items-center justify-center font-bold text-lg rounded hover:bg-white/30 transition-colors">-</button>
                </div>
            </div>

            <app-table [config]="roleTableConfig" [data]="roles"></app-table>

            <ng-template #emergencyRoleTemplate let-row="row">
                <div class="flex justify-center">
                    <input type="checkbox" [checked]="row.emergency"
                        class="w-5 h-5 border-slate-300 text-[#0d2e5e] cursor-pointer rounded">
                </div>
            </ng-template>
        </div>
    </form>
</div>